<template>
	<div
		class="smart-components-wrapper"
		:class="{
			'no-padding':
				!$store.state.main.mallType &&
				$route.params.path1 !== 'about-us' &&
				$route.params.path1 !== 'card-loyal',
			cabinet: cabinet,
		}"
	>
		<transition name="toggleContent" mode="out-in">
			<div v-if="changePage">
				<Search v-if="showSearch" />

				<landing-page
					v-if="
						!$store.state.main.mallType &&
							$route.params.path1 !== 'about-us' &&
							$route.params.path1 !== 'card-loyal'
					"
				/>
				<template v-else v-for="(component, componentKey) in loopComponents">
					<component
						:data-hash="_.get(component, 'hashTag')"
						:is="component.selectedComponent"
						:key="component.selectedComponent + componentKey"
						:contentData="getContentData(component)"
					/>
				</template>
			</div>
			<div class="empty-div-loader" v-else key="0"></div>
		</transition>
	</div>
</template>

<script>
import LandingPage from '../../components/pages/LandingPage.vue';
import Search from '@/components/modules/Search';
export default {
	components: { LandingPage, Search },
	name: 'smartComponentsLoader',
	props: {
		cabinet: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			hashName: '',
			top: false,
			single_view: false,
			changePage: false,
		};
	},
	created() {
		let components = _.get(this.$store.state.main.indx, 'smartComponents');

		for (let i in components) {
			// console.log('component: ', i);
			this.$options.components[i] = () => import('../../components/smartComponents/' + i);
		}

		if (this.$route.path.includes('singleview')) {
			this.single_view = true;
			console.log(this.single_view);
		}
		if (this.$store.state.main.selected_menu.configs.includes('map')) {
			document.body.classList.add('dark');
		}
	},
	mounted() {
		/*console.log(this.$route)*/
	},
	watch: {
		$route: {
			immediate: true,
			handler: function(to, from) {
				let _this = this;

				this.hashName = this.$route.hash.substring(1);
				console.log(from, 'from');
				this.$store.commit('main/setState', {
					key: 'store_pop_up',
					val: false,
				});
				if (_.get(from, 'path') != _.get(to, 'path')) {
					_this.changePage = false;

					setTimeout(function() {
						if (document.querySelector('[data-hash="' + _this.hashName + '"]')) {
							_this.top = document
								.querySelector('[data-hash="' + _this.hashName + '"]')
								.getBoundingClientRect().top;
						}

						if (_this.top && _this.$mq != 'tablet' && _this.$mq != 'phone' && _this.$mq != 'xs') {
							_this.$store.commit('setScrollTo', _this.top - 60);
						} else if (_this.top) {
							window.scrollTo({
								top: 5380,
								behavior: 'smooth',
							});
						}
						_this.changePage = true;
					}, 800);
				} else {
					_this.changePage = true;
				}

				if (this.$route.path.includes('singleview')) {
					this.single_view = true;
					console.log(this.single_view);
				} else {
					this.single_view = false;
				}

				if (this.$store.state.main.selected_menu.configs.includes('map')) {
					document.body.classList.add('dark');
				} else {
					document.body.classList.remove('dark');
				}
			},
		},
	},
	computed: {
		loopComponents() {
			let smartComponents = _.get(this.$store.state.main.selected_menu, 'secondary_data');
			let singleOrList = _.get(this.$store.state.main.selected_menu, 'routeParams.singleview')
				? 'single'
				: 'list';
			let componentTitles = [];
			let ret = [];
			for (let i in smartComponents) {
				if (_.get(smartComponents[i], 'enabled') != 1) continue;

				//// exclude component depend on menu settings
				if (singleOrList === 'list' && _.get(smartComponents[i], 'listLayout') != 1) {
					continue;
				} else if (singleOrList === 'single' && _.get(smartComponents[i], 'singleLayout') != 1) {
					continue;
				}

				ret.push(smartComponents[i]);
				componentTitles.push(smartComponents[i].selectedComponent);
				// console.log(i, smartComponents[i].selectedComponent, singleOrList, 'primary: '+_.get( smartComponents[i], 'primary'), smartComponents[i]);
			}
			/*        console.log('page components: ', _.map(ret, 'selectedComponent'), '; NOTE: if some component does not loads first check spelling and component exists!');*/
			return ret;
		},
		showSearch() {
			if (this.single_view) {
				return false;
			}
			if (
				// this.$store.state.main.selected_menu.configs.includes("shops") ||
				// this.$store.state.main.selected_menu.configs.includes("services") ||
				// this.$store.state.main.selected_menu.configs.includes("food") ||
				// this.$store.state.main.selected_menu.configs.includes("gldani-map") ||
				// this.$store.state.main.selected_menu.configs.includes(
				//   "saburtalo-map"
				// ) ||
				// this.$store.state.main.selected_menu.configs.includes(
				//   "entertainment"
				// ) ||
				// this.$store.state.main.selected_menu.configs.includes("offers")
				this.$store.state.main.selected_menu.configs.includes('show_search')
			) {
				return true;
			}
		},
	},
	methods: {
		getContentData(component) {
			let selectedComponent = _.get(component, 'selectedComponent');
			let componentUnicId = _.get(component, 'unicId');
			let primary = _.get(component, 'primary');
			let res = {};
			// console.log(selectedComponent, componentUnicId, primary, _.get(this.$store.state.main.current_content, ["primary", 'data', 'listCount']) );

			if (
				primary &&
				_.get(this.$store.state.main.current_content, ['primary', 'data', 'listCount'])
			) {
				// console.log(component);
				res = _.get(this.$store.state.main.current_content, ['primary']);
			}

			if (!_.get(res, 'conf.enabled')) {
				res.conf = _.get(this.$store.state.main.current_content, [
					'secondary',
					selectedComponent + '_' + componentUnicId,
					'conf',
				]);
			}
			if (!_.get(res, 'data.listCount')) {
				res.data = _.get(this.$store.state.main.current_content, [
					'secondary',
					selectedComponent + '_' + componentUnicId,
					'data',
				]);
			}

			return res;
		},
	},
};
</script>
<style lang="scss">
.smart-components-wrapper {
	&[path1='about-us'] {
		padding-top: 95px;
		@media (max-width: 1023px) {
			padding-top: 67px;
		}
	}
	&[path1='card-loyal'] {
		padding-top: 95px;
		@media (max-width: 1125px) {
			padding-top: 67px;
		}
	}
	&[path2='cabinet'] {
		padding-top: 0;
		@media (max-width: 1125px) {
			padding-top:0;
		}
	}
	// overflow-x: hidden;
	overflow: hidden;
	padding-top: 195px;
	/* min-height: 50vh; */
	@media (max-width: 1439px) {
		padding-top: 165px;
	}
	@media (max-width: 1023px) {
		padding-top: 65px;
	}
}
.smart-components-wrapper.no-padding {
	padding-top: 0;
}
body.dark {
	background-color: $darkblue;
}
.empty-div-loader {
	background: #ffffff;
	width: 100%;
	height: 100vh;
}
</style>
